export default __webpack_public_path__ + "static/media/daet-on-the-go.34dda41a.png";